import moment from "moment";
import _ from "lodash";
const color = {
  positive: "#07ad61",
  negative: "#eb0f29",
};
export const currencyFormatter = (amount, addSign) => {
  if (!amount) {
    return 0;
  } else {
    let formattedAmount = amount.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
    if (addSign) return amount > 0 ? "+ " + formattedAmount : formattedAmount;
    else return formattedAmount;
  }
};

export const indicatorStyleSetter = (amount) =>
  amount > 0
    ? {
        color: "#0b1721",
        fontSize: 12,
        fontWeight: "bold",
        color: color.positive,
      }
    : {
        color: "#0b1721",
        fontSize: 12,
        fontWeight: "bold",
        color: color.negative,
      };

export const labelTranslator = (label) => {
  switch (label) {
    case "comments":
      return "Comments";
    case "symbol":
      return "Symbol";
    case "cmp":
      return "CMP";
    case "entryPriceFrom":
      return "Entry Price From";
    case "entryPriceTo":
      return "Entry Price To";
    case "targetPriceFrom":
      return "Target Price From";
    case "targetPriceTo":
      return "Target Price To";
    case "slPrice":
      return "Stop Loss";
    case "advisoryType":
      return "Advisory Type";
    case "positionType":
      return "Position Type";
    case "validTill":
      return "Valid Till";
    case "exitedAt":
      return "Exited At";
    case "status":
      return "Status";
    case "quickTradeType":
      return "Trade Type";
    case "expiry":
      return "Expiry Type";
    case "equity":
      return "Equity";
    case "options":
      return "Options";
    case "futures":
      return "Futures";
    case "month":
      return "Month";
    case "week":
      return "Week";
    default:
      break;
  }
};

export const timestampToDate = (date) => moment(date).format("DD MMM HH:mm A");

export const handleUpdateDisable = (userRole, status) => {
  if (userRole === "admin") {
    return false;
  }
  if (userRole === "advisor") {
    if (status === "Waiting For Activation") {
      return false;
    } else if (status === "Activated") {
      let marketOpen = new Date().setHours(9, 30, 0, 0);
      let marketClose = new Date().setHours(15, 30, 0, 0);
      let currentTime = new Date().getTime();
      if (currentTime >= marketOpen && currentTime <= marketClose) return false;
      else return false;
    } else {
      return true;
    }
  }
};

export const getValidDate = (expiry, type) => {
  try {
    let dateAdjustment = 0;
    let calendarHolidayAdjustment = 0;
    let checkDate = moment(expiry);
    calendarHolidayAdjustment += getMarketHolidayCount(expiry);
    checkDate.add(calendarHolidayAdjustment, "d");
    if (
      (checkDate.day() === 6 && type === "2-3 Days") ||
      (checkDate.day() === 0 && type === "2-3 Days") ||
      (checkDate.day() === 1 && type === "2-3 Days") ||
      (checkDate.day() === 2 && type === "2-3 Days")
    ) {
      dateAdjustment = 2;
    } else if (checkDate.day() === 6 && !(type === "2-3 Days")) {
      dateAdjustment = 2;
    } else if (checkDate.day() === 0 && !(type === "2-3 Days")) {
      dateAdjustment = 1;
    }
    let adjustedDate = checkDate.add(dateAdjustment, "d");
    return adjustedDate;
  } catch (error) {
    console.log(error);
    return expiry;
  }
};

const getMarketHolidayCount = (expiry) => {
  let holiday;
  let result = 0;
  for (holiday of window.marketHolidayList) {
    if (moment(holiday).isBetween(moment(), expiry, undefined, "[]")) {
      result += 1;
    }
  }
  return result;
};

export const getEntryAndTargetPricesFromValues = (values) => {
  if (typeof values !== "object") {
    return;
  }
  let tempValues = _.cloneDeep(values);
  if (values.positionType === "BUY") {
    if (tempValues.entryPriceFrom > tempValues.entryPriceTo) {
      let prevEntryPriceTo = tempValues.entryPriceTo;
      tempValues.entryPriceTo = tempValues.entryPriceFrom;
      tempValues.entryPriceFrom = prevEntryPriceTo;
    }
    if (tempValues.targetPriceFrom > tempValues.targetPriceTo) {
      let prevTargetPriceTo = tempValues.targetPriceTo;
      tempValues.targetPriceTo = tempValues.targetPriceFrom;
      tempValues.targetPriceFrom = prevTargetPriceTo;
    }
  }
  else if (values.positionType === "SELL") {
    if (tempValues.entryPriceFrom < tempValues.entryPriceTo) {
      let prevEntryPriceTo = tempValues.entryPriceTo;
      tempValues.entryPriceTo = tempValues.entryPriceFrom;
      tempValues.entryPriceFrom = prevEntryPriceTo;
    }
    if (tempValues.targetPriceFrom < tempValues.targetPriceTo) {
      let prevTargetPriceTo = tempValues.targetPriceTo;
      tempValues.targetPriceTo = tempValues.targetPriceFrom;
      tempValues.targetPriceFrom = prevTargetPriceTo;
    }
  }
  return tempValues;
};


export const setValidTill = (value) => {
  let date;
  if (value == "INTRADAY") {
    date = moment().set("hour", 15).set("minute", 30).set("seconds", 0);
  } else if (value == "BTST") {
    date = moment(new Date())
      .add(1, "days")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "STBT") {
    date = moment(new Date())
      .add(1, "days")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "2-3 Days") {
    date = moment(new Date())
      .add(3, "days")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "1-Week") {
    date = moment(new Date())
      .add(1, "weeks")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "2-Weeks") {
    date = moment(new Date())
      .add(2, "weeks")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "3-Weeks") {
    date = moment(new Date())
      .add(3, "weeks")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "1-Month") {
    date = moment(new Date())
      .add(1, "months")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "3-Months") {
    date = moment(new Date())
      .add(3, "months")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else {
    date = moment(new Date())
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  }
  date = getValidDate(date, value);
  // if date falls on saturday or sunday
  // expiry will adjusted to next
  let dateResponse = new Date(date).getTime();
  return dateResponse;
};
export const extendValidTill = (value,currentValidTill) => {
  let date;
  let startDate = new Date(currentValidTill);
  if (value == "INTRADAY") {
    date = moment().set("hour", 15).set("minute", 30).set("seconds", 0);
  } else if (value == "BTST") {
    date = moment(startDate)
      .add(1, "days")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "STBT") {
    date = moment(startDate)
      .add(1, "days")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "2-3 Days") {
    date = moment(startDate)
      .add(3, "days")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "1-Week") {
    date = moment(startDate)
      .add(1, "weeks")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "2-Weeks") {
    date = moment(startDate)
      .add(2, "weeks")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "3-Weeks") {
    date = moment(startDate)
      .add(3, "weeks")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "1-Month") {
    date = moment(startDate)
      .add(1, "months")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else if (value == "3-Months") {
    date = moment(startDate)
      .add(3, "months")
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  } else {
    date = moment(startDate)
      .set("hour", 15)
      .set("minute", 30)
      .set("seconds", 0)
      .set("millisecond", 0);
  }
  date = getValidDate(date, value);
  // if date falls on saturday or sunday
  // expiry will adjusted to next
  let dateResponse = new Date(date).getTime();
  return dateResponse;
};